import { clone, debounce, set } from "lodash";
import * as React from "react";
import { Link } from "react-router-dom";
import { Alert, Button, Col, FormGroup, Label, Row, Input } from "reactstrap";
import axios from "../general/HttpClient";
import QRCodeView from "../general/QRCode";
import * as AccountStore from "./AccountStore";

const { Component } = React;

interface ProfileMultiFactorState {
    currentUser: any;
    showResendConfirmationModal: boolean;
    userUpdated: boolean;
    user: any;
    showUserUpdatedMessage: boolean;
    sharedKey: string;
    authenticatorUri: string;
}

export default class ProfileMultiFactor extends Component<any, ProfileMultiFactorState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: {},
            showResendConfirmationModal: false,
            userUpdated: false,
            user: { twoFactorEnabled: false },
            showUserUpdatedMessage: false,
            sharedKey: "",
            authenticatorUri: "",
        };
    }

    componentDidMount() {
        this.debouncedUpdate = debounce(() => {
            return AccountStore.UpdateUser(this.state.user).then((response) => {
                this.GetCurrentUser();
                this.setState({ showUserUpdatedMessage: true, userUpdated: true });
                setTimeout(() => {
                    this.setState({ showUserUpdatedMessage: false });
                }, 1000);
                return response;
            });
        }, 300);
        this.GetCurrentUser();
    }

    debouncedUpdate = () => {
        return AccountStore.UpdateUser(this.state.user).then((response) => {
            this.GetCurrentUser();
            this.setState({ showUserUpdatedMessage: true, userUpdated: true });
            setTimeout(() => {
                this.setState({ showUserUpdatedMessage: false });
            }, 1000);
            return response;
        });
    };

    GetCurrentUser = () => {
        AccountStore.GetCurrentLoggedInUser(true).then((user) => {
            this.setState({
                currentUser: user,
                user: clone(user),
            });
        });
    };

    handleProfileDataChange = (key) => (e) => {
        let value = e.target.value;
        this.setState((prevState) => {
            set(prevState.user, key, value);
            return { user: prevState.user, userUpdated: false };
        }, this.debouncedUpdate);
    };

    getAuthenticatorDetails = () => {
        axios.get("/api/AccountActions/GetAuthenticatorDetails").then((response) => {
            var { sharedKey, authenticatorUri } = response.data;
            this.setState({ sharedKey, authenticatorUri });
        });
    };

    resetAuthenticatorDetails = () => {
        this.setState({ sharedKey: "", authenticatorUri: "" });
        axios.post("/api/AccountActions/ResetAuthenticatorDetails").then((response) => {
            var { sharedKey, authenticatorUri } = response.data;
            this.setState({ sharedKey, authenticatorUri });
        });
    };

    updateUser = () => {
        AccountStore.UpdateUser(this.state.user).then((response) => {
            this.props.history.push("/");
        });
    };

    handleTwoFactorChange = (e) => {
        let value = e.target.checked;

        this.setState((prevState) => {
            prevState.user.twoFactorEnabled = value;
            return { user: prevState.user, userUpdated: false };
        }, this.debouncedUpdate);
    };

    render() {
        return (
            <div style={{ marginTop: "47px" }} className="px-4">
                <h1>
                    {this.state.currentUser.firstName} {this.state.currentUser.lastName}
                </h1>
                <h2>{this.state.currentUser.email}</h2>
                <p>{this.state.currentUser.userName}</p>

                <div className="m-2">
                    <Link to="/profile">Profile</Link>
                    <Link to="/profile/data" className="ms-2">
                        Data
                    </Link>
                    <Link to="/profile/mfa" className="ms-2">
                        MFA
                    </Link>
                    <Link to="/profile/security" className="ms-2">
                        Security
                    </Link>
                </div>

                <Row>
                    <Col md={12} lg={4}>
                        <FormGroup check>
                            <Input type="switch" label="" id="twoFactor" checked={this.state.user.twoFactorEnabled} onChange={this.handleTwoFactorChange} />
                            <Label for="twoFactor" check>Require Two Factor Authentication</Label>
                        </FormGroup>

                        {this.state.user.twoFactorEnabled && (
                            <>
                                {!this.state.authenticatorUri && (
                                    <Button color="info" onClick={this.getAuthenticatorDetails}>
                                        Get Authenticator Code
                                    </Button>
                                )}
                                {this.state.authenticatorUri && (
                                    <>
                                        <QRCodeView text={this.state.authenticatorUri}></QRCodeView>
                                        <Button color="warning" onClick={this.resetAuthenticatorDetails}>
                                            Reset Authenticator Code
                                        </Button>
                                        <div className="text-muted">{this.state.authenticatorUri}</div>
                                        <br />
                                        <div className="text-muted">{this.state.sharedKey}</div>
                                    </>
                                )}
                            </>
                        )}

                        {this.state.showUserUpdatedMessage && (
                            <Alert color="success" className="p-2">
                                Profile updated successfully
                            </Alert>
                        )}
                    </Col>
                </Row>
            </div>
        );
    }
}
